import { useCallback } from 'react';
import { useApi, fetchApiRef } from '@backstage/frontend-plugin-api';
import type { CheckDefinition } from '@internal/backstage-plugin-pulse-common';
import { checksResponseSchema } from '../schemas/checks';
import {
  PULSE_CACHE_KEYS,
  PULSE_QUERY_CACHE_POLICIES,
  useCachedQuery,
} from './cache';

type UsePulseChecksOptions = {
  enabled?: boolean;
  cache?: boolean;
};

export const usePulseChecks = ({
  enabled = true,
  cache = true,
}: UsePulseChecksOptions = {}) => {
  const { fetch } = useApi(fetchApiRef);

  const fetchChecks = useCallback(async () => {
    const response = await fetch('plugin://pulse/checks');

    if (!response.ok) {
      throw new Error(
        `Failed to fetch checks: ${response.status} ${response.statusText}`,
      );
    }

    const data = await response.json();
    const parsed = checksResponseSchema.parse(data);

    return parsed.checks as CheckDefinition[];
  }, [fetch]);

  return useCachedQuery({
    cacheKey: PULSE_CACHE_KEYS.checks,
    fetcher: fetchChecks,
    ...PULSE_QUERY_CACHE_POLICIES.definitions,
    enabled,
    useSharedCache: cache,
  });
};
